import { ISettingsTransactionsDto } from '@shared/api';
import { formats } from '@shared/utils';
import moment from 'moment';

export const transformDate = (key: string, transaction: ISettingsTransactionsDto) => {
    if (key === 'date' || key === 'settlementDate') {
        return moment(String(transaction[key])).format(formats.fullTime);
    }
    return transaction[key].toString();
};
